"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_transform_1 = require("prosemirror-transform");
var isEmptyDoc = function (doc) {
    return doc.childCount === 1 && !doc.firstChild.content.size && doc.firstChild.type === doc.type.contentMatch.defaultType;
};
exports.isEmptyDoc = isEmptyDoc;
var isOriginAttrs = function (node, nodeType) {
    if (nodeType === void 0) { nodeType = node.type; }
    var typeAttrs = nodeType.spec.attrs;
    if (!typeAttrs)
        return;
    var attrNames = Object.keys(typeAttrs);
    return !attrNames.some(function (name) {
        if (typeof typeAttrs[name].default === undefined || node.attrs[name] === typeAttrs[name].default)
            return false;
        return true;
    });
};
exports.isOriginAttrs = isOriginAttrs;
function findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) {
        for (var i = $pos.depth - 1; i >= 0; i--) {
            if ($pos.index(i) > 0) {
                return $pos.doc.resolve($pos.before(i + 1));
            }
            if ($pos.node(i).type.spec.isolating) {
                break;
            }
        }
    }
    return null;
}
exports.findCutBefore = findCutBefore;
function getPrevNodeLastTextBlock($pos) {
    var curNode = $pos.nodeBefore;
    var depth = 0;
    var pos = $pos.pos;
    while (curNode) {
        pos = $pos.pos - curNode.nodeSize - depth;
        if (curNode.isTextblock) {
            break;
        }
        curNode = curNode.lastChild;
        depth++;
    }
    return { node: curNode, pos: pos };
}
exports.getPrevNodeLastTextBlock = getPrevNodeLastTextBlock;
var REMOVE_ALL = '_';
var splitStr = function (str) { return (str ? str.split(/\s+/) : []); };
/**
 * 收集excludeMarks和marks的信息，用于清除
 * @param node
 * @param excludeMarkList excludeMarks保存数组
 * @param whiteList marks保存数组
 */
var handleSpecInfo = function (node, excludeMarkList, whiteList) {
    if (!node)
        return false;
    var _excludeMarkList = splitStr(node.type.spec.excludeMarks);
    var _whiteList = splitStr(node.type.spec.marks);
    if (excludeMarkList.includes(REMOVE_ALL))
        return true;
    if (whiteList.includes(''))
        return true;
    excludeMarkList.push.apply(excludeMarkList, _excludeMarkList);
    _whiteList.push.apply(_whiteList, _whiteList);
    return false;
};
/**
 * 获取当前位置节点excludeMarks的内容
 * 返回可以兼容marks列表
 * @param $pos
 */
var getFitMarksHandler = function ($pos) {
    var depth = $pos.depth + 1;
    var excludeMarkList = [];
    var whiteList = [];
    var removeAll = false;
    var pointerNode = $pos.nodeAfter;
    removeAll = handleSpecInfo(pointerNode, excludeMarkList, whiteList);
    while (depth--) {
        var parentNode = $pos.node(depth);
        removeAll = handleSpecInfo(parentNode, excludeMarkList, whiteList);
    }
    if (excludeMarkList.length + whiteList.length === 0)
        return;
    return function (marks) {
        if (removeAll)
            return [];
        return marks.filter(function (mark) {
            if (excludeMarkList.includes(mark.type.name))
                return false;
            if (whiteList.length && !whiteList.includes(mark.type.name))
                return false;
            return true;
        });
    };
};
/**
 * 移除Node不能包含的mark，识别自定义字段 excludeMarks，处理marks
 * @param tr
 */
var removeExcludesMarks = function (tr) {
    var _a = tr.selection, $from = _a.$from, $to = _a.$to;
    var isRemoved = false;
    tr.doc.nodesBetween($from.depth ? $from.before() : $from.pos, $to.depth ? $to.after() : $to.pos, function (node, pos, parent, index) {
        if (node.isLeaf && node.marks.length) {
            var fitRule = getFitMarksHandler(tr.doc.resolve(pos));
            if (fitRule) {
                var newMarks = fitRule(node.marks);
                if (newMarks.length === node.marks.length)
                    return;
                parent.content = parent.content.replaceChild(index, node.isText
                    ? node.type.schema.text(node.textContent, newMarks)
                    : node.type.create(node.attrs, node.content, newMarks));
                isRemoved = true;
            }
        }
        return !node.isLeaf;
    });
    return isRemoved;
};
exports.removeExcludesMarks = removeExcludesMarks;
var getUnInheritAttr = function (node) {
    if (!node || !node.type.spec.attrs)
        return [];
    return Object.keys(node.type.spec.attrs).filter(
    // @ts-ignore
    function (key) { return node.type.spec.attrs[key].inherit === false; });
};
exports.getUnInheritAttr = getUnInheritAttr;
/**
 * 重置inherit为false的节点属性，处理当前选区
 * @param node
 */
var resetUnInheritAttr = function (oldState, newState) {
    if (oldState.doc === newState.doc)
        return;
    var $oFrom = oldState.selection.$from;
    var $nFrom = newState.selection.$from;
    if (!$oFrom.depth || !$nFrom.depth || $oFrom.before() === $nFrom.before()) {
        return;
    }
    var oldNode = $oFrom.parent;
    var newNode = $nFrom.parent;
    if (oldNode.type !== newNode.type || oldNode === newNode)
        return;
    getUnInheritAttr(oldNode).forEach(function (key) {
        var _a;
        if (oldNode.attrs[key] === newNode.attrs[key]) {
            if (oldNode.attrs === newNode.attrs) {
                newNode.attrs = __assign(__assign({}, newNode.attrs), (_a = {}, _a[key] = newNode.type.attrs[key].default, _a));
            }
            else {
                newNode.attrs[key] = newNode.type.attrs[key].default;
            }
        }
    });
};
exports.resetUnInheritAttr = resetUnInheritAttr;
/**
 * 检查是否是单层嵌套文本块
 * @param node nodeType
 */
var checkIsNestedTextBlock = function (node) {
    if (node.inlineContent)
        return false;
    var count = node.contentMatch.edgeCount - 1;
    if (count < 0)
        return false;
    while (count >= 0) {
        if (!node.contentMatch.edge(count).type.inlineContent) {
            return false;
        }
        count--;
    }
    return true;
};
exports.checkIsNestedTextBlock = checkIsNestedTextBlock;
/**
 * 多个range的情况下（CellSelection）, from和to不正确
 * @param selection
 */
var getRealFromTo = function (selection) {
    var from = selection.from, to = selection.to;
    selection.ranges.forEach(function (_a) {
        var $from = _a.$from, $to = _a.$to;
        from = Math.min($from.pos, from);
        to = Math.max($to.pos, to);
    });
    return { from: from, to: to };
};
exports.getRealFromTo = getRealFromTo;
var removeMark = function (doc, tr, from, to) {
    var matched = [];
    var step = 0;
    doc.nodesBetween(from, to, function (node, pos) {
        if (!node.isInline)
            return;
        step++;
        var toRemove = node.marks;
        if (toRemove && toRemove.length) {
            var end = Math.min(pos + node.nodeSize, to);
            for (var i = 0; i < toRemove.length; i++) {
                var style = toRemove[i];
                var found = void 0;
                for (var j = 0; j < matched.length; j++) {
                    var m = matched[j];
                    if (m.step === step - 1 && style.eq(matched[j].style))
                        found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                }
                else {
                    // 当MarkType声明了notClear === true, 不被清除格式
                    if (!style.type.spec.notClear) {
                        matched.push({ style: style, from: Math.max(pos, from), to: end, step: step });
                    }
                }
            }
        }
    });
    matched.forEach(function (m) { return tr.step(new prosemirror_transform_1.RemoveMarkStep(m.from, m.to, m.style)); });
    return tr;
};
exports.removeMark = removeMark;
//# sourceMappingURL=prose-util.js.map